import * as Preact from "preact"
import Pointer from "poin"

import App from "@fae/source/models/App.js"
import Step from "@fae/source/models/Step.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Audiomix from "@fae/source/engine/Audiomix.js"
// import Random from "@fae/source/utility/Random.js"
// const random = new Random()

import Dice from "@fae/source/data/games/ember/views/Dice.jsx"
import Icon from "@fae/source/data/games/ember/views/Icon.jsx"
import UnitManagementSection from "@fae/source/data/games/ember/views/UnitManagementSection.jsx"

import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

import items from "@fae/source/data/games/ember/items.jsx"

import "./MerchantModal.less"

const ITEM_COST = 3
const REROLL_COST = 1
const ITEM_SELL_VALUE = 1

function getDraftableItems(stage) {
    // if(stage.overworld.player.encounter.items != undefined) {
    //     return stage.overworld.player.encounter.items
    // }

    // const units = Object.values(stage.units).filter((unit) => {
    //     return unit.isDead != true
    //         && unit.isRecruited == true
    //         && unit.affiliation == stage.player.affiliation
    //         && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
    // })

    let draftableItems = []
    draftableItems = Object.values(items).filter((item) => item.isDraftable == true)

    if((stage?.overworld?.player?.position?.x || 0) <= 3) { // TODO: UNHARDCODE THIS!!!
        draftableItems = Object.values(items).filter((item) => item.draftTier == 1)
    }

    draftableItems = draftableItems.map((item) => ({...item}))
    draftableItems = stage.random.shuffle(draftableItems)

    let draftLength = 4 + Math.floor((stage.overworld.player.position.x || 0) / 4)
    draftableItems = draftableItems.slice(0, draftLength)

    return draftableItems
}

export default function() {
    return PlotSteps.CustomViewModal({
        "view": (stage) => {
            if(App?.game == undefined) return
            return <MerchantModal stage={stage}/>
        }
    })
}

class MerchantModal {
    render() {
        const stage = this.props.stage
        if(window.draftableItems === undefined) {
            window.draftableItems = getDraftableItems(stage)
        }
        if(window.goldCount === undefined) {
            window.goldCount = 10 + (window.extraGold || 0)
        }

        return (
            <div class="MerchantModal" hasSelectedItem={window.selectedItem != undefined}>
                <div class="SelectedItemCursor" style={{"top": Pointer.position.y, "left": Pointer.position.x}}>
                    <Dice item={window.selectedItem} anchored={"bottom"}/>
                </div>
                <div class="StatusSection">
                    <div class="GoldCount">
                        {window.goldCount} silver
                    </div>
                </div>
                <div class="ButtonsSection">
                    <div class="DoneButton" onClick={this.onClickContinue(stage)} isVisible={true}>
                        Onwards
                    </div>
                </div>
                <UnitManagementSection stage={stage} direction="vertical"/>
                <div class="ItemsSection" onMouseDown={this.onClickItemShop("down")} onMouseUp={this.onClickItemShop("up")}>
                    {window.draftableItems.map((item) => {
                        if(item == null
                        || window.selectedItem == item) {
                            return (
                                <div class="EmptyItem">
                                    <Dice item={null}/>
                                </div>
                            )
                        }
                        return (
                            <div class="DraftableItem"
                                isDraftable={window.goldCount >= ITEM_COST} isSelected={window.selectedItem == item}>
                                <Dice item={item} onMouseDown={this.onClickDraftableItem(item)} anchored="top"/>
                                <div class="Cost">{ITEM_COST} silver</div>
                            </div>
                        )
                    })}
                    <div class="RerollButton" onMouseDown={this.onClickRerollButton()} isClickable={window.goldCount >= REROLL_COST} anchored="top">
                        <div class="IconBox">
                            <Icon iconKey="rolling-energy"/>
                        </div>
                        <div class="Label">
                            <div class="Title"><span>Reroll Stock</span></div>
                        </div>
                        <div class="Cost">{REROLL_COST} silver</div>
                    </div>
                </div>
                {this.tutorial}
            </div>
        )
    }
    get tutorial() {
        return [
            (
                <div class="Tutorial" style={{"top": "4.25em", "left": "-0.1em"}} isStarted={true} isDone={window.hasRightClickedCount >= 4 || window.hasBoughtSomething == true}>
                    <div class="Fill" size="big"/>
                    <div class="Message" position="top">
                        <div class="Box">
                            <div class="Text">
                                These are the items you can buy!!<br/>
                                Right-click to learn more about them.
                            </div>
                        </div>
                    </div>
                </div>
            ),
            (
                <div class="Tutorial" style={{"top": "-4.1em", "left": "-7.05em"}} isStarted={window.hasBoughtSomething} isDone={window.hasDismissedSilver}>
                    <div class="Fill" size="small"/>
                    <div class="Message" position="right" size="small" style={{"left": "9.2em"}}>
                        <div class="Box">
                            <div class="Text">
                                This is your remaining silver.
                                <div class="Link" onClick={() => window.hasDismissedSilver = true}>
                                    ✖ Dismiss
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ),
            (
                <div class="Tutorial" style={{"top": "-3.5em", "left": "5.5em"}} isStarted={window.hasDismissedSilver == true && window.window.couldTriple} isDone={window.hasDismissedTriple || window.hasTripled}>
                    <div class="Message" position="center" size="small">
                        <div class="Box">
                            <div class="Text">
                                You have bought three-of-a-kind!!<br/>
                                Put them in a row to combine them.
                                <div class="Link" onClick={() => window.hasDismissedTriple = true}>
                                    ✖ Dismiss
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ),
            (
                <div class="Tutorial" style={{"top": "3.5em", "left": "5.5em"}} isStarted={Object.values(window.draftableItems).filter((item) => !!item).length == 0} isDone={window.hasRerolled}>
                    <div class="Message" position="center" size="small">
                        <div class="Box">
                            <div class="Text">
                                You've bought out the shop!!<br/>Hit the spiral to refresh the stock.
                            </div>
                        </div>
                    </div>
                </div>
            ),


        ]
    }
    onClickRerollButton() {
        return (event) => {
            const MOUSE_BUTTON = 0
            if(event.button != MOUSE_BUTTON) return

            if(window.goldCount < REROLL_COST) return
            window.goldCount -= REROLL_COST
            window.draftableItems = getDraftableItems(this.props.stage)
            Audiomix.trigger("Merchant:Gems")
            window.hasRerolled = true
        }
    }
    onClickDraftableItem(item) {
        return function(event) {
            const MOUSE_BUTTON = 0
            if(event.button != MOUSE_BUTTON) return
            
            if(this.hasBeenCounted != true) {
                this.hasBeenCounted = true
                window.hasRightClickedCount = window.hasRightClickedCount || 0
                window.hasRightClickedCount += 1
            }

            if(window.goldCount < 3) return
            if(window.selectedItem == undefined) {
                window.selectedItem = item
                window.selectedItemSlotKey = "merchant"
                Audiomix.trigger("Selection:Start")
                event.stopPropagation()
            }
        }
    }
    onClickItemShop(eventDirection) {
        return function(event) {
            const MOUSE_BUTTON = 0
            if(event.button != MOUSE_BUTTON) return

            if(eventDirection == "down" // || (eventDirection == "up" && itemSlotKey != window.selectedItemSlotKey)
            && window.selectedItem != undefined) {
                if(window.selectedItemSlotKey == "merchant") {
                    // console.log("dropping back", window.selectedItem)
                    window.selectedItemSlotKey = undefined
                    window.selectedItem = undefined
                    Audiomix.trigger("Selection:Cancel")
                } else {
                    // console.log("selling", window.selectedItem)
                    window.selectedItemSlotKey = undefined
                    window.selectedItem = undefined
                    window.goldCount += ITEM_SELL_VALUE
                    Audiomix.trigger("Merchant:Coins:Single")
                }
            }
        }
    }
    onClickContinue(stage) {
        return function(event) {
            if(window.selectedItem != undefined) return
            window.navigatedModalScreen = undefined
            window.draftableItems = undefined
            window.goldCount = undefined
            CarryOn(stage)
        }
    }
}
